import {
  Box,
  Button,
  CircularProgress,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { styles } from "../styles";
import SearchIcon from "@mui/icons-material/Search";
import WheelInfoCard from "./WheelInfoCard";
import { colors } from "../../../../../utils";
import TextView from "../../../../TextView";
import { useParams } from "react-router-dom";

const BrowseWheels = ({
  handleSearch,
  searchedText,
  selectedFilter,
  handleFilterChange,
  wheelDropdownOptions,
  //selectedWheelId,
  wheels,
  onWheelClick,
  onLoadMore,
  isLoading,
  hideLoadMore,
  onSearchIconClick,
}) => {
  const { id } = useParams();
  console.log(id);
  return (
    <Stack>
      <Stack
        direction={"row"}
        my={2}
        gap={"10px"}
        alignContent={"center"}
        justifyContent={"center"}
      >
        <Select
          value={selectedFilter}
          onChange={handleFilterChange}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          sx={styles.dropdownStyle}
          MenuProps={{
            sx: {
              "& .MuiMenuItem-root": {
                borderBottom: "1px solid #E1E1E1",
              },
            },
          }}
        >
          {wheelDropdownOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              sx={{
                color: selectedFilter === option ? "black" : "#BBBBBB",
                fontSize: "14px",
                fontFamily: "DM Sans",
                fontWeight: "400",
                mx: 1,
                pl: 0,
              }}
            >
              {option}
            </MenuItem>
          ))}
        </Select>

        <TextField
          sx={styles.searchTextField}
          placeholder="Search Wheel"
          label=""
          value={searchedText}
          variant="outlined"
          onChange={handleSearch}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon
                  color="action"
                  sx={{ cursor: "pointer" }}
                  onClick={onSearchIconClick}
                />
              </InputAdornment>
            ),
            style: styles.searchInput,
          }}
        />
      </Stack>

      <Stack
        style={{
          overflowY: "auto",
          height: "40vh",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
      >
        <style>
          {`
      .custom-stack::-webkit-scrollbar {
        display: none;
      }
    `}
        </style>
        {wheels.length === 0 && isLoading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            sx={{ py: 5 }}
          >
            <CircularProgress />
          </Box>
        )}

        {!isLoading && wheels.length === 0 && (
          <Box
            sx={{
              py: 5,
              backgroundColor: "#F6F7F9",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <TextView
              style={{
                fontWeight: "500",
                color: "#123051",
                fontSize: "20px",
                lineHeight: "25px",
                textAlign: "center",
              }}
            >
              No Wheels Available!
            </TextView>
          </Box>
        )}

        {wheels.length > 0 && (
          <Stack gap={1}>
            {wheels.map(
              (wheel) =>
                // selectedWheelId !== wheel.id &&
                wheel.id !== parseInt(id) && (
                  <WheelInfoCard
                    wheelData={wheel}
                    onWheelClick={onWheelClick}
                  />
                )
            )}
          </Stack>
        )}

        {wheels.length > 0 && hideLoadMore && (
          <Button
            onClick={onLoadMore}
            variant="contained"
            sx={{
              margin: "20px auto",
              display: "block",
              backgroundColor: colors.purple,
              width: "10vw",
              padding: "10px",
            }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={16} /> : "Load More"}
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default BrowseWheels;
